import { render, staticRenderFns } from "./IosInappBrowserWarningDialog.vue?vue&type=template&id=40ebed48&scoped=true"
import script from "./IosInappBrowserWarningDialog.vue?vue&type=script&lang=js"
export * from "./IosInappBrowserWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./IosInappBrowserWarningDialog.vue?vue&type=style&index=0&id=40ebed48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ebed48",
  null
  
)

export default component.exports